import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useEffect, useState } from 'preact/hooks';
import { useUserProfile } from '@/hooks/useUserProfile';
import { clientCompanyApi } from '@/api/clientCompany';
import { AuthenticationSettings } from './auth/AuthenticationSettings';
export function SettingsAuthentication({ clientCompanyId }) {
    const { canManageCustomers, userProfile } = useUserProfile();
    const [company, setCompany] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        const effectiveCompanyId = clientCompanyId || userProfile?.ClientCompanyId;
        if (!effectiveCompanyId) {
            setError('No company selected');
            setLoading(false);
            return;
        }
        let cancelled = false;
        setLoading(true);
        setError(null);
        clientCompanyApi.getById(effectiveCompanyId)
            .then(res => {
            if (cancelled)
                return;
            if (res.error || !res.data) {
                setError(res.error || 'Failed to load company');
                setCompany(null);
            }
            else {
                setCompany(res.data);
            }
        })
            .catch(() => {
            if (!cancelled)
                setError('Failed to load company');
        })
            .finally(() => {
            if (!cancelled)
                setLoading(false);
        });
        return () => { cancelled = true; };
    }, [clientCompanyId, userProfile?.ClientCompanyId]);
    if (!canManageCustomers) {
        return (_jsx("div", { className: "p-6 max-w-4xl mx-auto", children: _jsxs("div", { className: "bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4", children: [_jsx("div", { className: "text-amber-800 dark:text-amber-300 font-medium mb-1", children: "Not authorized" }), _jsx("div", { className: "text-sm text-amber-700 dark:text-amber-300", children: "You don\u2019t have permission to manage authentication for this company." })] }) }));
    }
    if (loading) {
        return (_jsx("div", { className: "p-6 max-w-4xl mx-auto", children: _jsx("div", { className: "flex items-center justify-center py-12", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "text-slate-400 mb-4", children: _jsx("svg", { className: "w-16 h-16 mx-auto", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", d: "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" }) }) }), _jsx("h3", { className: "text-lg font-medium text-slate-900 dark:text-white mb-2", children: "Loading Authentication" }), _jsx("p", { className: "text-slate-600 dark:text-slate-300", children: "Preparing authentication settings\u2026" })] }) }) }));
    }
    if (error || !company) {
        return (_jsx("div", { className: "p-6 max-w-4xl mx-auto", children: _jsxs("div", { className: "bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg p-4", children: [_jsx("div", { className: "text-red-700 dark:text-red-400 font-medium mb-1", children: "Error" }), _jsx("div", { className: "text-sm text-red-600 dark:text-red-300", children: error || 'Unable to load company' })] }) }));
    }
    return (_jsx(AuthenticationSettings, { clientCompanyId: company.Id, displayName: company.Name, authOrgId: company.AuthOrganizationId }));
}
